<template>
  <div class="pages">
    <div class="search_box">
      <van-dropdown-menu>
        <van-dropdown-item :title="area_title" v-model="area" :options="areas" @change="onAreaChange" />
      </van-dropdown-menu>
      <div class="search_bar">
        <van-search v-model="keywords" shape="round" placeholder="请输入搜索关键词" @search="onSearch" @clear="onClear" />
      </div>
    </div>
    <div v-if="list.length">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadData">
          <div class="employ_box" v-for="item in list" :key="item" @click="onClickDetail(item.position_id)">
            <div class="position_name">{{ item.position_name }}</div>
            <div class="label_list">
              <div class="label">{{ item.area }}</div>
              <div class="label">{{ item.position_type }}</div>
              <div class="label">{{ item.people_num }}</div>
            </div>
            <div class="publish_at">{{ item.publish_at }}</div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <div v-else-if="list.length <= 0 && page_show">
      <van-empty :image="Util.getImgUrl(empty_msg.image)" :description="empty_msg && empty_msg.title ? empty_msg.title : '描述文字'" />
    </div>
    <van-popup v-model="popup_show" round closeable position="bottom" :style="{ height: '90%' }">
      <div class="detail_box" v-if="detail">
        <div class="detail_header">
          <div class="position_name2">{{ detail.position_name }}</div>
          <div class="label_list2">
            <van-icon name="location-o" size="16px" />
            <span>{{ detail.area }}</span>
            <van-icon name="apps-o" size="16px" />
            <span>{{ detail.position_type }}</span>
            <van-icon name="friends-o" size="16px" />
            <span>{{ detail.people_num }}</span>
          </div>
          <div class="publish_at2">{{ detail.publish_at }}发布</div>
        </div>
        <div class="detail_center">
          <div class="center_title">
            <div class="left_tip"></div>
            <div>工作职责</div>
          </div>
          <div class="center_content">
            <p class="content_textarea">{{ detail.responsibility }}</p>
          </div>
          <div class="center_title">
            <div class="left_tip"></div>
            <div>任职资格</div>
          </div>
          <div class="center_content">
            <p class="content_textarea">{{ detail.qualification }}</p>
          </div>
        </div>
        <div class="height_block"></div>
        <div class="detail_footer">
          <van-button type="info" block
            @click="$router.push({ name: 'employ2.position.post', query: post_router.args })">立即申请</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import wx from 'weixin-js-sdk'

export default {
  data() {
    return {
      page_show: false,
      popup_show: false,
      detail: null,
      keywords: '',
      area_title: '地点',
      area: '全部',
      areas: [],
      page: 1,
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      position_type: '',
      empty_msg: null,
    }
  },
  mounted() {
    this.position_type = this.$route.query.position_type
    document.title = this.position_type ? this.position_type : '中船航海人才招聘'
    setTimeout(() => {
      this.loadData()
    }, 1000)
  },
  methods: {
    loadData() {
      let that = this
      that.$api.employPositionList({
        page: that.page,
        keywords: that.keywords,
        area: that.area == '全部' ? '' : that.area,
        position_type: that.position_type
      }).then(res => {
        if (that.page == 1) {
          that.list = []
          that.areas = res.data.areas
        }
        that.list = that.list.concat(res.data.records.data)
        that.loading = false
        that.refreshing = false
        if (!res.data.records.next_page_url) {
          that.finished = true
        } else {
          that.page += 1
        }
        that.empty_msg = res.data.empty_msg
        that.page_show = true
      })
    },
    onRefresh() {
      this.finished = false
      this.loading = true
      this.page = 1
      this.loadData();
    },
    onAreaChange(e) {
      console.log('onAreaChange', e);
      this.area_title = e == '全部' ? '地点' : e
      this.onRefresh()
    },
    onSearch() {
      console.log('onSearch');
      this.onRefresh()
    },
    onClear() {
      console.log('onClear');
      this.onRefresh()
    },
    onClickDetail(position_id) {
      let that = this
      that.popup_show = true
      that.$api.employPositionDetail({
        position_id: position_id,
      }).then(res => {
        that.detail = res.data.record
        that.post_router = res.data.path.post
      })
    }
  }
}
</script>
<style scoped>
*>>>.van-dropdown-menu__bar {
  box-shadow: none !important;
}
</style>
<style scoped src="./positionList.css"></style>
    